export const LOAD_GENERAL_STATISTICS = 'LOAD_GENERAL_STATISTICS';
export const LOAD_PROJECT_STATISTICS = 'LOAD_PROJECT_STATISTICS';
export const LOAD_PASSIVE_RISK_SCORE = 'LOAD_PASSIVE_RISK_SCORE';
export const RESET_PASSIVE_RISK_SCORE = 'RESET_PASSIVE_RISK_SCORE';
export const LOAD_CLOUD_SERVICES_STATISTICS = 'LOAD_CLOUD_SERVICES_STATISTICS';
export const RECALCULATE_RISK_SCORE = 'RECALCULATE_RISK_SCORE';
export const RECALCULATE_RISK_SCORE_BULK = 'RECALCULATE_RISK_SCORE_BULK';
